// FIX-CCS-A2-PLUMBING (unit A2, R18) — the build stamp this app carries on what it writes.
//
// Every value comes from the build (vite.config.ts `define` → __APP_VERSION__, filled from the
// Cloudflare Pages env CF_PAGES_COMMIT_SHA / CF_PAGES_BRANCH, else from git). Nothing here is a
// typed string: a stale or hand-edited stamp would defeat the point (splitting rows by build).
//
// Carried on:
//   - photos.precapture_metadata.app (schema_version 3)      — src/utils/photoPreCapture.ts
//   - activities.client_meta on every CCS activity insert    — ActivityLog/DailyRecord/Home/Camera screens, useActivities
//   - the Sentry release                                      — src/config/sentry.ts

// A type alias (not an interface) so it is assignable to the generated Json column type.
export type AppBuildStamp = {
  version: string;
  commit: string;
  branch: string;
  build_time: string;
};

export const APP_BUILD: AppBuildStamp = Object.freeze({
  version: __APP_VERSION__.version,
  commit: __APP_VERSION__.commit,
  branch: __APP_VERSION__.branch,
  build_time: __APP_VERSION__.buildTime,
});
